import { Empty } from 'antd';
import React, { FC } from 'react';
import { InView } from 'react-intersection-observer';
import styled from 'styled-components';
import { ReactComponent as EndImage } from 'assets/svgs/end.svg';
import { Alert } from 'components/atoms/alert';
import { useTranslation } from 'hooks/use-translation';
import { Fetched, FetchedLastPage, Fetching } from 'stores/notifications';

const End = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
`;

export const Footer: FC<{ content: Fetched | Fetching | FetchedLastPage }> = ({
  content,
}) => {
  const endOfList = useTranslation('notifications.messages.end_of_list');
  const fetching = useTranslation('notifications.messages.fetching');

  return (
    <End>
      {content[0] === 'fetching' && (
        <Alert key={content[0]} message={fetching} type="info" />
      )}
      {content[0] === 'fetched' && (
        <InView
          key={`fetched-${content[1][2][1]}`}
          as="div"
          onChange={(inView) => inView && content[4]()}
        >
          <Alert message={fetching} type="info" />
        </InView>
      )}
      {content[0] === 'fetched_last_page' && content[2].length > 0 && (
        <Empty image={<EndImage />} description={endOfList} />
      )}
    </End>
  );
};
